import { RodeoEvent } from "./rodeoEvent";

export class RodeoEventCarryOver {
    rodeoEventId: number;
    carryOverId: number;
    carryOver: RodeoEvent;
    sourceRound: number;
    destinationRound: number;
    required: boolean;
    excludeShortGo: boolean;
}


// WEBPACK FOOTER //
// ./src/model/rodeoEventCarryOver.ts